<template>
  <DesertMessage
    v-if="isDocumentEmpty"
    class="bg-neutro-200 rounded"
    :mainTitle="dessertMessage.mainTitle"
    :mainContent="dessertMessage.mainContent"
  />
  <div v-else :key="reRender">
    <div class="mb-6">
      <p class="font-bold">{{ information.fullname }}</p>
    </div>
    <div class="mb-6">
      <p class="font-bold">
        {{ $t('message.documentDetail.commons.cuil') }}:
      </p>
      <p>{{ information.cuil }}</p>
    </div>
    <div class="mb-6">
      <p class="font-bold">
        {{ $t('message.documentDetail.information.entrydate') }}:
      </p>
      <p>{{ information.entrydate }}</p>
    </div>
    <div class="mb-6">
      <p class="font-bold">
        {{ $t('message.documentDetail.information.email') }}:
      </p>
      <div class="flex justify-between items-center">
        <p>{{ information.email }}</p>
        <zt-button
          icon="copy"
          :disabled="!information.email"
          outlined
          @click="copyToClipboard"
        >
          <span v-if="copiedText">
            {{ $t('message.documentDetail.information.copiedText') }}
          </span>
          <span v-else>
            {{ $t('message.documentDetail.information.copyEmail') }}
          </span>
        </zt-button>
      </div>
    </div>
    <div class="mb-6">
      <p class="font-bold">
        {{ $t('message.documentDetail.information.sector') }}:
      </p>
      <p>{{ information.sector }}</p>
    </div>
    <div class="mb-6">
      <p class="font-bold">
        {{ $t('message.documentDetail.information.location') }}:
      </p>
      <p>{{ information.location }}</p>
    </div>
    <div class="mb-6">
      <p class="font-bold">
        {{ $t('message.documentDetail.information.countsigned') }}:
      </p>
      <p>{{ information.countsigned }}</p>
    </div>
    <div class="mb-6">
      <p class="font-bold">
        {{ $t('message.documentDetail.information.countunsigned') }}:
      </p>
      <p>{{ information.countunsigned }}</p>
    </div>
    <div>
      <div class="flex justify-end">
        <zt-button
          outlined
          :disabled="!information.iduser"
          @click="
            $router.push({
              name: 'employee',
              params: { id: information.iduser }
            })
          "
        >
          {{ $t('message.documentDetail.information.viewEmployeeProfile') }}
        </zt-button>
      </div>
    </div>
  </div>
</template>

<script>
import DesertMessage from '@/components/generics/DesertMessage404.vue'

export default {
  name: 'Information',
  components: { DesertMessage },
  inject: ['stateDetailStore'],
  data() {
    return {
      information: {
        cuil: '',
        fullname: '',
        entrydate: '',
        email: '',
        sector: '',
        location: '',
        countsigned: '',
        countunsigned: '',
        iduser: ''
      },
      reRender: 0,
      copiedText: false
    }
  },
  computed: {
    isDocumentEmpty() {
      return !this.information.cuil
    },
    dessertMessage() {
      return {
        mainTitle: this.$t('message.documentDetail.information.empty.title'),
        mainContent: this.$t(
          'message.documentDetail.information.empty.content',
          {
            identificator: 'cuil'
          }
        )
      }
    }
  },
  watch: {
    stateDetailStore: {
      handler() {
        if (this.stateDetailStore.detail.dataUser) {
          this.information = { ...this.stateDetailStore.detail.dataUser }
          this.reRender += 1
        }
      },
      deep: true
    }
  },
  created() {
    this.information = this.stateDetailStore.detail.dataUser
    this.reRender += 1
  },
  methods: {
    async copyToClipboard() {
      this.copiedText = true
      try {
        await navigator.clipboard.writeText(this.information.email)
        setTimeout(() => {
          this.copiedText = false
        }, 250)
      } catch (err) {
        this.copiedText = false
      }
    }
  }
}
</script>

<style scoped>
.bg-neutro-200 {
  background-color: #ebebeb;
}
</style>
